<template>
  <el-dialog
    :title="'Нэмэх дүн'"
    :visible.sync="isShow"
    @close="mCloseFunction"
    @closed="mCloseFunction"
    :before-close="close"
    :close-on-click-modal="isOpenDialog"
    v-loading="loading"
    width="30%"
    v-if="additionalValue"
  >
    <el-form v-model="additionalValue">
      <el-form-item>
        <el-tag type="info"
          >Харилцагч: {{ additionalValue.partner_name }}</el-tag
        >
      </el-form-item>
      <el-form-item label="Дүн">
        <el-input
          v-model="zoruu_dun"
          type="number"
          :rows="5"
        ></el-input>
      </el-form-item>
      <el-form-item label="Тайлбар">
        <el-input
          type="textarea"
          v-model="desc"
          :rows="5"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="is_accepted">Зөвшөөрөх</el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="mCloseFunction">Болих</el-button>
      <el-button
        type="success"
        @click="additional"
        :disabled="isDisable"
      >Хадгалах</el-button>
    </div>
  </el-dialog>
</template>
<script>
import services from '@/helpers/partnerServices.js'
import { getGroups, getEmail } from '@/utils/auth.js'
export default {
  name: 'AdditionalSettlementDialog',
  props: {
    isShow: Boolean,
    currentAdditionSalary: Object,
    close: Function,
    closeFunction: Function,
    formatPrice: Function,
    getSettlementFunction: Function,
    additionalValue: Object,
    outletId: String
  },
  data () {
    return {
      loading: false,
      isOpenDialog: false,
      zoruu_dun: 0,
      desc: '',
      is_accepted: false,
      group: [],
      isDisable: false,
      email: ''
    }
  },
  async created () {
    this.start()
    this.email = await getEmail()
  },
  methods: {
    async start () {
      this.group = await getGroups()
      if (this.group.includes('view')) this.isDisable = true
    },
    mCloseFunction () {
      this.closeFunction()
    },
    async additional () {
      this.loading = true
      try {
        const payload = {
          settlement_status: 30,
          settlement_id: this.additionalValue.settlement_id.toString(),
          settlement_amount: this.zoruu_dun,
          settlement_note: this.desc,
          is_accepted: this.is_accepted,
          outlet_id: this.outletId,
          from: 'manage',
          email: this.email
        }

        const { data } = await services.acceptSettlement(payload)

        if (data?.status === 'success') {
          this.$notify.success({
            title: 'Амжилттай',
            position: 'bottom-left',
            message: 'Амжилттай',
            duration: 2000
          })

          this.zoruu_dun = 0
          this.desc = ''
          this.is_accepted = false

          this.mCloseFunction()
          this.getSettlementFunction()
        } else {
          this.$notify.error({
            title: 'Уучлаарай',
            position: 'bottom-left',
            message: data?.message || 'Алдаа гарлаа',
            duration: 2000
          })
        }
      } catch (error) {
        this.$notify.error({
          title: 'Уучлаарай',
          position: 'bottom-left',
          message: error?.message || 'Серверийн алдаа гарлаа',
          duration: 2000
        })

        this.$store.commit('pushError', {
          type: 'warning',
          title: 'Уучлаарай',
          description: 'Алдаа гарлаа'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
